<template>
	<v-data-table
		:headers="headers"
		:items="usuarios"
		:search="search"
		sort-by="nombre"
		class="elevation-1"
	>
    <template v-slot:top>
		<v-toolbar flat color="white">
			<v-toolbar-title>Ordenes</v-toolbar-title>
			<v-divider
			class="mx-4"
			inset
			vertical
			></v-divider>
		<v-spacer></v-spacer>
			<v-text-field
			v-model="search"
			append-icon="mdi-magnify"
			label="Buscar"
			single-line
			hide-details
			></v-text-field>
			<v-spacer></v-spacer>
			<v-dialog v-model="comprobanteModal" max-width="1000px">
				<v-card class="pa-3 factura">
					<v-btn class="oculto-impresion mx-2" color="accent" dark="" @click="descargarPDF()"> <v-icon>mdi-printer</v-icon> PDF</v-btn>
					<div ref="pdfContent" id="factura">
						<html lang="en">
							<head>
							<meta charset="utf-8" />
							<meta http-equiv="X-UA-Compatible" content="IE=edge">
							<meta name="viewport" content="width=device-width, initial-scale=1">
							<link href="images/favicon.png" rel="icon" />
							<title>Orden {{IdReparacion}} - {{$store.state.usuario.localidad}} </title>
							<meta name="author" content="harnishdesign.net">
							<!-- Web Fonts
							======================= -->
							<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900' type='text/css'>
							<!-- Stylesheet
							======================= -->
							<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/bootstrap/css/bootstrap.min.css"/>
							<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/font-awesome/css/all.min.css"/>
							<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/css/stylesheet.css"/>
							</head>
							<body>
							<!-- Container -->
							<div class="container-fluid invoice-container">
							
							<!-- Main Content -->
							<main>
							<div class="table-responsive">
								<table >
									<thead >
										<tr>
											<td class="col-5"><img height="120" :src="localidadencabezado[0].imagen"></td>
											<td class="col-4 text-center"> <strong> {{$store.state.usuario.localidad}} </strong> <br />
											{{localidadencabezado[0].razonSocial}}<br />
											{{localidadencabezado[0].dirreccion}}<br />
											{{localidadencabezado[0].cedulaJuridica}}<br />
											{{localidadencabezado[0].telefono}}<br />
											{{localidadencabezado[0].correo}}<br /> </td>
											<td class="col-1 text-end"><h4 class="text-7 mb-0"><strong> Orden: {{IdReparacion}} </strong></h4></td>
										</tr>
									</thead>
								</table>
							</div>
							<hr>
							<table>
								<tbody>
									<tr>
										<td class="col-2 text-start text-1"><address>
											
											<strong> Cliente:</strong> {{clienteNombre}} - {{nombreComercial}} <br>
											<strong> Cédula: </strong> {{clienteCedula}}<br>
											<strong> Teléfono: </strong> {{clienteTelefono}}<br>
											<strong> Correo: </strong> {{clienteCorreo}} <br>
											<strong>Ingreso en Grua:</strong> {{ ingresoEnGrua ? 'Sí' : 'No' }}
											</address>
										</td>
										<td class="col-2 text-end text-1"><address>
											<strong> Placa:</strong> {{serie}} <br>
											<strong> Marca:</strong> {{marca}} <br>
											<strong> Modelo:</strong> {{modelo}}<br />
											<strong> Color:</strong> {{referencia}}<br />
											<strong> Generado por:</strong> {{$store.state.usuario.nombre}}
											</address>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="grey lighten-2 black--text text-center py-2">
								Inventario
							</div>
							<div class="fuel-indicator">
								<v-row class="py-0">
									<v-col cols="12" md="12" v-for="item in inventarioFiltrado" :key="item.name" class="py-1 px-1">
										✓ {{item.name}}
									</v-col>
									<p> <strong> Combustible :% </strong>{{fuelLevel}}</p>

									<div class="car-container">
										<img src="https://www.noah.cr/ImagenesGenerales/DanosCarro.png" alt="Carro"> <!-- Reemplaza con la ruta a tu imagen del carro -->
									</div>
								</v-row>
							</div>
							<div class="card">
								<div class="card-body p-0">
								<div class="table-responsive">
									<table class="table mb-0">
									<thead class="card-header">
										<tr>
											<td class="col-3"><strong>Item</strong></td>
											<td class="col-6"><strong>Precio</strong></td>
										</tr>
									</thead>
									<tbody>
										<tr v-for="det in items" :key="det.id">
											<td class="col-8 text-1"> {{ det.Nombre }} </td>
											<td class="col-4 text-0">
												<b>{{ det.PrecioUnitario }} </b>
											</td>
										</tr>
									</tbody>
									<tfoot class="card-footer">
										<tr>
											<td colspan="2" class="text-2 text-end"><strong> Total:{{costo}} </strong></td>
										</tr>
									</tfoot>
									</table>
								</div>
								</div>
							</div>
							</main>
							<!-- Footer -->
							<footer class="text-center text-1">
								<p style="white-space: pre-line;"><b> Cuentas Bancarias:</b>  <br>  {{Cuentas}}  </p>
								{{localidadencabezado[0].pieDocumento}}
							</footer>
							</div>
							</body>
						</html>
					</div>
					<v-btn @click="comprobanteModal = false" color="error" flat><v-icon> mdi-exit-to-app </v-icon></v-btn>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialog" max-width="1200">
			<template v-slot:activator="{ on }">
				<v-btn color="info" dark class="mb-2" @click="NuevaOrden()" v-on="on">Nueva Orden</v-btn>
				</template>
				<v-card>
					<v-toolbar dark color="primary">
						<v-toolbar-title>Nueva Orden de servicio</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn @click="comprobanteModal = true"> PDF </v-btn>
						<v-toolbar-items>
							<v-btn icon dark @click="dialog = false">
							<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar-items>
					</v-toolbar>
					<v-container fluid>
					<v-row>
						<v-col cols="12" sm="12">
						<v-form ref="form" v-model="validCliente"  @submit.prevent="RegistrarOrden()">
							<v-row>
								<v-col cols="12" sm="6">
									<v-combobox
									filled
									hide-details
									clearable
									@change="obtenerCliente()"
									dense
									v-model="idcliente"
									:items="clientes"
									label="Cliente"
									>
									<template v-slot:append>
										<v-btn icon small @click.stop="dialogcliente = true">
										<v-icon>mdi-account-multiple-plus</v-icon>
										</v-btn>
									</template>
									</v-combobox>
									<v-select filled hide-details="" v-model="vendedor" append-icon="mdi-briefcase-account" :items="Vendedores" color="success" :label="`Mecanico a cargo`"></v-select>
									<v-text-field filled hide-details="num" label="Kilometraje" v-model="Kilometraje"/>
								</v-col>
								<v-col cols="12" sm="3">
									<v-text-field clearable filled hide-details="" v-model="serie" label="Serie o Placa"></v-text-field>
									<v-text-field clearable filled hide-details="" v-model="marca" type="text" label="Marca"/>
									
									<v-textarea v-model="falla"  auto-grow
										filled hide-details="" 
										rows="1"
										label="Falla reportada">
									</v-textarea>
								</v-col>
								<v-col cols="12" sm="3">
									<v-text-field clearable filled hide-details="" v-model="modelo" :rules="[v => !!v || 'El Modelo es requerido']" type="text" label="Modelo"></v-text-field>
									<v-text-field clearable filled hide-details="" v-model="referencia" :rules="nameRules" required type="text" label="Color"></v-text-field>
									<v-select 
										clearable 
										filled hide-details="" 
										v-model="domicilio" 
										:items="['Si', 'No']" 
										label="Ingreso en Grua">
									</v-select>
								</v-col>
								<v-col cols="12" sm="12" >
									<div class="grey lighten-2 black--text text-center py-2">
										Inventario
									</div>
								</v-col> 
								
								<v-col cols="12" sm="8">
								<v-row class="py-0"> <!-- Reduce el padding vertical de v-row -->
									<v-col cols="12" md="3" v-for="item in inventario" :key="item.name" class="py-1 px-1"> <!-- Ajusta el padding de cada v-col -->
										<v-checkbox dense :label="item.name" v-model="item.checked"></v-checkbox>
									</v-col>
								</v-row>
								</v-col>
									<!-- Columna del Indicador de Combustible -->
								<v-col cols="12" md="4">
								<div class="fuel-indicator">
									<div class="car-container">
										<v-slider
										v-model="fuelLevel"
										:max="100"
										:min="0"
										direction="vertical"
										hint="Seleccione nivel de combustible"
										persistent-hint
										prepend-icon="mdi-gas-station-outline"
										append-icon="mdi-gas-station"
										thumb-label="always"
										></v-slider>
									</div>
									<!-- Agrega aquí otros elementos si necesitas -->
								</div>
								</v-col>
								<v-col cols="12" sm="12">
									<div class="grey lighten-2 black--text text-center py-2">
										Productos o Servicios \ <strong> Total: {{costo=calcluarTotal}} </strong>
									</div>
										<v-combobox :loading="loading" id="buscador" filled clearable onfocus="this.select();"  prepend-inner-icon="mdi-briefcase-outline" @keyup="selectProductos()" @change="buscarProductoDirecto()" :items="productos" v-model="codigo" label="Código de producto o servicio"></v-combobox>
										<v-simple-table>
											<template v-slot:default>
											<thead>
												<tr>
												<th class="text-left">
													Item
												</th>
												<th class="text-left">
													Precio
												</th>
												<th class="text-left">
													Eliminar
												</th>
												</tr>
											</thead>
											<tbody>
												<tr
												v-for="item in items"
												:key="item.name"
												>
												<td>
													<v-edit-dialog
													:return-value.sync="item.Nombre"
													@save="ActualizarItem(item)"
													large
													>
													{{item.Nombre}}
													<template v-slot:input>
														<v-text-field onfocus="this.select();" autofocus v-model="item.Nombre" label="Nombre"/>
													</template>
													</v-edit-dialog>

												</td>
												<td>
													<v-edit-dialog
													:return-value.sync="item.PrecioUnitario"
													@save="ActualizarItem(item)"
													large
													>
													{{item.PrecioUnitario}}
													<template v-slot:input>
														<v-text-field onfocus="this.select();" autofocus v-model="item.PrecioUnitario" label="Precio"/>
													</template>
													</v-edit-dialog>
												</td>
												<td><v-icon @click="eliminarLinea(item.id)">mdi-delete </v-icon></td>
												</tr>
											</tbody>
											</template>
										</v-simple-table>
									<div>
										<div class="grey lighten-2 black--text text-center py-2">
										Daños Pre existentes
										</div>
										<div class="car-container" style="position: relative;">
										<canvas id="carCanvas" width="1000" height="300" style="position: absolute; z-index: 1;"></canvas>
										<img src="https://www.noah.cr/ImagenesGenerales/DanosCarro.png" alt="Carro" style="position: relative; z-index: 0;">
										</div>
										<v-btn @click="clearCanvas">Limpiar Selecciones</v-btn> <!-- Botón para limpiar las selecciones -->
									</div>
								</v-col>
								<v-col cols="12" sm="6" class="red--text">
								<v-textarea v-model="nota"  auto-grow
									filled
									rows="1" hide-details=""
									row-height="30"
									label="Nota del Cliente">
									</v-textarea>
									<v-text-field clearable filled hide-details="" v-model="domicilio" type="text" label="Domicilio"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
								<v-text-field  clearable v-model="adelanto" filled hide-details="" required type="number" label="Adelanto"></v-text-field>
								{{error}} 
								<v-btn v-if="IdReparacion == 0" :loading="loading" type="submit" :disabled="!validCliente" color="primary" id="espacioBoton"  class="mr-4" style="top: 10px;">
									Registrar Orden
								</v-btn>
								<v-btn color="teal darken-1" id="espacioBoton" class="mr-4" style="top: 10px; color: white;" @click="limpiar()">
								<v-icon> mdi-update </v-icon>
								</v-btn>
								<v-btn color="error" id="espacioBoton" @click="dialog = false">
								<v-icon> mdi-exit-to-app </v-icon>
								</v-btn>
								</v-col>
								<v-col cols="12" sm="6" class="red--text">
								
								</v-col>
								
							</v-row>
						
						</v-form>
						</v-col>
					</v-row>
					</v-container>
					</v-card>
			</v-dialog>
			<v-dialog
			v-model="modelCarga"
			width="300"
			dark
			>
			<v-card
				color="white"
				
			>
				<v-card-text class="black--text">
				Por Favor, Espere..
				<v-progress-linear
					indeterminate
					color="black"
					class="mb-0"
				></v-progress-linear>
				</v-card-text>
				<v-img
					src="https://i.pinimg.com/originals/e2/6d/87/e26d873ee68fbcd9dc1c40d8b0c6b3b4.gif"
					class="my-3"
					contain
					height="200"
				></v-img>
			</v-card>
			</v-dialog>
			<v-dialog v-model="dialogcliente" max-width="1200">
				<v-card>
					<v-toolbar dark color="primary">
						<v-toolbar-title>{{ formTitle }}</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-toolbar-items>
							<v-btn icon dark @click="dialogcliente = false">
							<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar-items>
					</v-toolbar>
					<v-container fluid>
					<v-row>
						<v-col cols="12" sm="12">
						<v-form ref="form" v-model="validCliente"  @submit.prevent="guardar()">
							<v-row>
								<v-col cols="12" sm="3">
								<v-text-field @change="BuscarPersona()" clearable v-model="cedula" :rules="cedulaRules" required type="text" label="Número Documento"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
								<v-text-field clearable v-model="nombre" :rules="nameRules" required type="text" label="Nombre"></v-text-field>
								</v-col>
								<v-col cols="12" sm="3">
								<v-select v-model="tipoDocumento" :rules="[v => !!v || 'El tipo de documento es requerido']" :items="tipoDocumentos" label="Tipo Documento"></v-select>
								</v-col>
								<v-col cols="12" sm="2">
								<v-text-field clearable v-model="telefono" type="tel" label="Teléfono"></v-text-field>
								</v-col>
								<v-col cols="12" sm="2">
								<v-text-field   clearable v-model="celular" type="tel" label="Telefono 2"></v-text-field>
								</v-col>
								<v-col cols="12" sm="2">
								<v-text-field clearable v-model="edad"  type="tel" label="Edad"></v-text-field>
								</v-col>
								<v-col cols="12" sm="3">
								<v-text-field clearable v-model="correo" :rules="emailRules" type="email" label="Correo Electrónico"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="red--text">
								<v-textarea v-model="direccion"  auto-grow
									outlined
									rows="1"
									dense
									row-height="30"
									shaped label="Dirección"></v-textarea>
								</v-col>
								<v-col cols="12" sm="6">
								<v-text-field  clearable v-model="nombreFantasia"  required type="text" label="Nombre Empresa o Tarjeta"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="red--text">
								{{error}} 
								</v-col>
								<v-btn :loading="loading" type="submit" :disabled="!validCliente" color="primary" id="espacioBoton"  class="mr-4" style="top: 10px;">
								{{ formTitle }}
								</v-btn>
								<v-btn color="teal darken-1" id="espacioBoton" class="mr-4" style="top: 10px; color: white;" @click="limpiar()">
								<v-icon> mdi-update </v-icon>
								</v-btn>
								<v-btn color="error" id="espacioBoton" @click="dialogcliente = false">
								<v-icon> mdi-exit-to-app </v-icon>
								</v-btn>
							</v-row>
						
						</v-form>
						</v-col>
					</v-row>
					</v-container>
					</v-card>
			</v-dialog>

			</v-toolbar>
	</template>
	<template v-slot:item.estado="props">
			<v-edit-dialog
			:return-value.sync="props.item.id"
			@save="ActualizarOrden(props.item)"
			large
			>
				<v-chip :color="getColor(props.item.estado)" :text-color="getColorText(props.item.estado)">• {{ props.item.estado }}</v-chip> <br>
			<template v-slot:input>
				<v-select  v-model="props.item.estado" :items="estadosReparaciones" label="Estado"/>
			</template>
			</v-edit-dialog>
	</template>
	<template v-slot:item.cliente="props">
			<v-edit-dialog
			:return-value.sync="props.item.cliente"
			@save="ActualizarOrden(props.item)"
			large
			>
			{{props.item.cliente}}
			<template v-slot:input>
				<v-text-field  v-model="props.item.cliente" label="Nombre"/>
			</template>
			</v-edit-dialog>
	</template>
	<template v-slot:item.nota="props">
			<v-edit-dialog
			:return-value.sync="props.item.nota"
			@save="ActualizarOrden(props.item)"
			large
			>
			{{props.item.nota}}
			<template v-slot:input>
				<v-text-field  v-model="props.item.nota" label="nota"/>
			</template>
			</v-edit-dialog>
	</template>
	<template v-slot:item.falla="props">
			<v-edit-dialog
			:return-value.sync="props.item.falla"
			@save="ActualizarOrden(props.item)"
			large
			>
			{{props.item.falla}}
			<template v-slot:input>
				<v-text-field  v-model="props.item.falla" label="falla"/>
			</template>
			</v-edit-dialog>
	</template>
	<template v-slot:item.costo="props">
			<v-edit-dialog
			:return-value.sync="props.item.costo"
			@save="ActualizarOrden(props.item)"
			large
			>
			{{props.item.costo}}
			<template v-slot:input>
				<v-text-field  v-model="props.item.costo" label="costo"/>
			</template>
			</v-edit-dialog>
	</template>
	<template v-slot:item.adelanto="props">
			<v-edit-dialog
			:return-value.sync="props.item.adelanto"
			@save="ActualizarOrden(props.item)"
			large
			>
			{{props.item.adelanto}}
			<template v-slot:input>
				<v-text-field  v-model="props.item.adelanto" type="num" label="costo"/>
			</template>
			</v-edit-dialog>
	</template>
	<template v-slot:item.tecnico="props">
			<v-edit-dialog
			:return-value.sync="props.item.tecnico"
			@save="ActualizarOrden(props.item)"
			large
			>
			{{props.item.tecnico}}
			<template v-slot:input>
				<v-select :items="Vendedores"  v-model="props.item.tecnico" label="tecnico"/>
			</template>
			</v-edit-dialog>
	</template>
    <template v-slot:item.action="{ item }">
      <v-icon
        
        class="mr-2"
        color="primary" 
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <template >
      <v-icon
        color="error"
        @click="EliminarOrden(item)"
      > 
        mdi-delete
      </v-icon>
    </template>
     
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
	
  	</v-data-table>
  
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

  	export default {
	data: () => ({
		dialog: true,
		search: '',
		idcliente: '',
		referencia: '',
		modelo: '',
		modelCarga: true,
		articulo: '',
		localidadencabezado:[],
		items:[],
		ingresoEnGrua:false,
		Cuentas:null,
		marca: '',
		Placa:'',
		accesorios:[],
		telefonoReceptor:'',
		correoReceptor:'',
		inventario: [
			{ name: 'Gato', checked: false },
			{ name: 'Herramientas', checked: false },
			{ name: 'Triángulos', checked: false },
			{ name: 'Alfombras', checked: false },
			{ name: 'Llanta refacción', checked: false },
			{ name: 'Extintor', checked: false },
			{ name: 'Antena', checked: false },
			{ name: 'Emblemas', checked: false },
			{ name: 'Tapones de rueda', checked: false },
			{ name: 'Cables', checked: false },
			{ name: 'Estéreo', checked: false },
			{ name: 'Encendedor', checked: false },
			{ name: 'Gata', checked: false },
			{ name: 'Estereo o Radio', checked: false },
			// Asegúrate de agregar o quitar elementos según los que tengas en tu inventario real
		],
		estado: '',
		falla: '',
		nota: '',
		costo: 0,
		danios: {
			delanteroIzquierdo: false,
			// Repite para cada área que necesites
		},
		adelanto: 0,
		iconoActivo: false, // Este será tu modelo para el ícono, repite para cada ícono que necesites
		headers: [
			{ text: 'Opciones', value: 'action', sortable: false },
			{ text: 'Id', value: 'id' },
			{ text: 'Cliente', value: 'cliente' },
			{ text: 'Placa', value: 'serie' },
			{ text: 'Marca', value: 'marca' },
			{ text: 'Modelo', value: 'modelo' },
			{ text: 'Tecnico', value: 'tecnico' },
			{ text: 'Estado', value: 'estado', },
			{ text: 'Falla', value: 'falla',  },
			{ text: 'Nota', value: 'nota',  },
			{ text: 'Fecha', value: 'fecha',},
			{ text: 'Usuario', value: 'usuario'},
			{ text: 'Costo', value: 'costo',},    
			{ text: 'Adelanto', value: 'adelanto',},          
		],
		search: '',
			editedIndex: -1,
			id: '',
			idrol:'',
			generos: ["MASCULINO","FEMENINO"],
			tipoDocumentos: [
			'FISICA',
			'JURIDICA',
			'EXTRANJERO',
			],
			roles:[                   
			],
			nombre:'',
			dialogcliente: false,
			correo2: '',
			error: null,
			IdReparacion:0,
			comprobanteModal:false,
			clienteTelefono: "",
			clienteCorreo:"",
			clienteCedula:"",
			correo: '',
			DiasCreditoCliente: 15,
			tipo_documento: '',
			documentos: ['DNI','DIMEX','Cédula Fisica','Cédula Juridica'],
			num_documento: '',
			direccion: '',
			cedula: '',
			edad: 0,
			listasDePrecios: ["Precio Venta", "Precio Detalle", "Precio Central","Precio Mayor", "Precio Mall"],
			listaDePrecio: 'Precio Venta',
			genero: '',
			direccion: '',
			fechanacimiento :'',
			timeouts: [],
			estadosReparaciones:["PENDIENTE","REPARADO","NO SE PUDO REPARAR","ENTREGADO"],
			Vendedores : [],
			usuarios:[],    
			telefono: '',
			productos:[],
			localidades:[],
			localidadesColor:[],
			idusuario: '',
			idLocalidadCliente: null,
			localidad: null,
			condicion: true,
			cedulaRules: [
			value => !!value || 'La cédula es requerida'
			],
			nameRules: [
				value => !!value || 'El nombre es requerido',
				value => (value && value.length >= 3) || 'Debe ingresar 3 carácteres como mínimo',
			],
			emailRules: [
			v => !!v || 'El correo electrónico es requerido',
			v => /.+@.+\..+/.test(v) || 'El correo electrónico es requerido debe ser válido',
			] ,
			email: '',
			password:'',
			fuelLevel:50,
			actPassword:false,
			vendedor: '',
			nombreComercial: "",
			nombreFantasia: "",
			tipoDocumento : "",
			codigo:0,
			passwordAnt:'',
			valida: 0,
			validCliente: false,
			Kilometraje:0,
			domicilio:"",
			points: [],
			serie:"",
			snackbar:false,
			Mensaje: "",
			clienteNombre:"",
			validaMensaje:[],
			loading: false,
			NoEmpleado: '',
			adModal: 0,
			celular:"",
			limiteCredito: 0,
			adAccion: 1,
			adNombre: '',
			adId: ""  ,
			isDrawing: false,
      		context: null,
			clientes: [],
			desserts: [],
    }),

    computed: {
      	formTitle () {
                return this.editedIndex === -1 ? 'Nuevo Cliente' : 'Actualizar Cliente'
        },
		inventarioFiltrado() {
			return this.inventario.filter(item => item.checked);
		},
		calcluarTotal(){
			var resultado = 0;
			for(var i=0;i<this.items.length;i++){
				resultado += parseInt(this.items[i].PrecioUnitario);
			}
			return resultado;
		},

    },

    watch: {
    },
	mounted() {
		this.initCanvas();
	},

    created () {
		//this.initCanvas();
		// this.listar();
		// this.selectMecanicos();
		// this.select();
		// this.listarLocalidad();
    },

    methods: {
		adjustCanvasSize() {
		const img = document.getElementById('carImage');
		const canvas = document.getElementById('carCanvas');
		canvas.width = img.clientWidth;
		canvas.height = img.clientHeight;
		},
		initCanvas() {
		const img = document.getElementById('carImage');
		const canvas = document.getElementById('carCanvas');
		const ctx = canvas.getContext('2d');

		// Ajustar el tamaño del canvas cuando la imagen esté completamente cargada
		if (img.complete) {
			this.adjustCanvasSize();
		} else {
			img.onload = () => {
			this.adjustCanvasSize();
			};
		}

		canvas.addEventListener('click', (e) => {
			const rect = canvas.getBoundingClientRect();
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;
			this.points.push({ x, y });
			this.drawPoints(ctx);
		});
		},
		drawPoints(ctx) {
		ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
		this.points.forEach(point => {
			ctx.beginPath();
			ctx.arc(point.x, point.y, 5, 0, 2 * Math.PI);
			ctx.fillStyle = 'red';
			ctx.fill();
			ctx.stroke();
		});
		},
		clearCanvas() {
		const canvas = document.getElementById('carCanvas');
		const ctx = canvas.getContext('2d');
		ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpiar el canvas
		this.points = []; // Vaciar los puntos seleccionados
		},
		getColor (mensajeRespuesta) {
			if (mensajeRespuesta == 'PENDIENTE') return 'indigo lighten-4'
			if(mensajeRespuesta == 'REPARADO') return 'orange lighten-4'
			if(mensajeRespuesta == 'NO SE PUDO REPARAR') return 'red-lighten-4'
			else  return 'ENTREGADO'
		},
		getColorText (mensajeRespuesta) {
			if (mensajeRespuesta == 'PENDIENTE') return 'indigo darken-4'
			if(mensajeRespuesta == 'REPARADO') return 'orange darken-4'
			if(mensajeRespuesta == 'NO SE PUDO REPARAR') return 'red-darken-4'
			else  return 'ENTREGADO'
		},
		select(){
			let me=this;
			var clientesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
				axios.get('api/Empleados/SelectEmpleadosLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				clientesArray=response.data;
				clientesArray.map(function(x){
					me.clientes.push({text: (x.nombre+' | '+x.nombreFantasia), text2:x.nombre,value:x.idEmpleado});
				});
			})
		},
		selectProductos(){
			let me=this;
			let Objeto = [];
			let myInput = document.getElementById('buscador');
			myInput = myInput.value;
			let cant = myInput.length;
			if ( cant > 2 ) {
				var search_term = myInput;
				
				this.timeouts.map( timeout => {
					window.clearTimeout( timeout );
				} );
				this.timeouts.push(
					setTimeout( () => {
						this.loading = true;
						axios.get('api/Productos/BuscadorEnter/'+this.$store.state.usuario.localidad+'/'+myInput).then( response => {
							Objeto = response.data
								// Cargar Productos 
								Objeto.map(function(x){
									me.productos.push({text:x.descripcion, value:x.codigoProducto});
								});
								me.loading = false;
							} )
							.catch( error => { } );
					}, 500 )
				);
			} else {
				this.timeouts.map( timeout => {
					window.clearTimeout( timeout );
				} );
				this.productos = [];
			}
		},
		listarLocalidad(){
            let me =this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
			axios.get('api/Localidades/ListarFiltrada/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.localidadencabezado=response.data;
				}).catch(function(error){
					console.log(error);
				});
                
		},
		buscarProductoDirecto(){
			let me=this;
			if (this.codigo.value === undefined)
			{
				this.codigo = this.codigo;
			}
			else
			{
				this.codigo = this.codigo.value;
			}

			if (this.codigo != "")
			{
				let header={"Authorization" : "Bearer "};
				let configuracion= {headers : header};
				axios.get('api/Productos/BuscarCodigoVenta/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
				.then(function(response){
					me.agregarDetalleDirecto(response.data);
				}).catch(function(error){
					//alert(error);
					console.log(error);
				});
			}
		},
		agregarDetalleDirecto(data = []){
			var ImpuestoIncluido= "I.V.N.I."
			var item = data;
			if (data['codigoProducto'] != '' && data['codigoProducto'] != undefined)
			{
				this.codigo = data['codigoProducto'];
			}
				if (this.codigo != '')
				{ 
					if(data['estadoInventario'] == true){
					ImpuestoIncluido= "I.V.I"
					}
					this.items.push(
						{
						id: this.items.length + 5, 
						idarticulo:data['codigoProducto'],
						Nombre:data['descripcion'],
						cantidad:1,
						PrecioUnitario:data['precioVenta'],
						Cabys:data['codigoRaiz'],
						ValorImpuesto:data['valorImpuesto']
						}
						);
						this.codigo = '';
					if(this.IdReparacion != 0){
						this.AgregarProducto(item);
					}
				}
				else
				{
					this.Mensaje = "Debe digitar un código de producto o servicio.";
					this.snackbar = true;
			}
		},
		async AgregarProducto(item){
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
			await axios.post('api/ProductosComprasMaps',{
				'Nombre':item.descripcion,
				'cantidad':1,
				'CodigoProducto':item.codigoProducto,
				'PrecioUnitario':item.precioVenta,
				'Cabys':item.codigoRaiz,
				'ValorImpuesto':item.valorImpuesto,
				'Clave':this.IdReparacion,
			},configuracion).then(function(response){
				//alert("Orden Registrada con exito");
				me.Mensaje = 'Item Registrado con exito en Orden  '+me.IdReparacion+response;
				me.snackbar = true;          
				me.selectItems(me.IdReparacion)  ;     
			}).catch(err => {
				this.loading =false;
				//console.log(err.response);
				if (err.response.status==400){
					this.error="Correo ocupado por otro cliente";
				} else if (err.response.status==404){
					this.error="Cédula Ocupada por otro cliente";
				}else{
					this.error="Validar Campos Vacios";
				}
			});
		},
		async ActualizarOrden(item){
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
			await axios.put('api/Reparaciones/'+item.id,{
				'Nombre':item.cliente,
				'CodigoProducto':item.articulo,
				'PrecioUnitario':item.id,
				'Domicilio': item.domicilio,
				'Marca': item.marca,
				'Modelo':item.modelo,
				'Tecnico': item.tecnico,
				'Falla':item.falla,
				'Nota': item.nota,
				//'Fecha':fechaISO, // Ingresar Fecha aqui
				'Serie':item.serie,
				'Adelanto':item.adelanto,
				'Referencia':item.referencia,
				'Usuario':this.$store.state.usuario.nombre,
				'Accesorios':item.accesorios,
				'Estado':item.estado,
				'Costo':item.costo,
				'Capacidad':item.capacidad,
				'Localidad':this.$store.state.usuario.localidad,
			},configuracion).then(function(response){
				//alert("Orden Registrada con exito");
				me.Mensaje = 'Actualizado con exito '+response;
				me.snackbar = true;
				me.dialog = false;
				me.listar();
				me.loading =false;                      
			}).catch(err => {
				this.loading =false;
				//console.log(err.response);
				if (err.response.status==400){
					this.error="Correo ocupado por otro cliente";
				} else if (err.response.status==404){
					this.error="Cédula Ocupada por otro cliente";
				}else{
					this.error="Validar Campos Vacios";
				}
			});

		},
		eliminarLinea(id) {
			this.items = this.items.filter(e => e.id != id)
			if(this.IdReparacion != 0){
				this.EliminarProductoCompra(id);
			}
		},
		async EliminarProductoCompra(item){
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
				await axios.delete('api/ProductosComprasMaps/'+item,{
				},configuracion).then(function(response){
					//alert("Orden Registrada con exito");
					me.Mensaje = 'Registro eliminado con exito '+response;
					me.snackbar = true;                  
				}).catch(err => {
					this.loading =false;
					//console.log(err.response);
					if (err.response.status==400){
						this.error="Problema eliminando producto";
					} else if (err.response.status==404){
						this.error="Problema eliminando";
					}else{
						this.error="NO se pudo eliminar";
					}
				});
		},
		async ActualizarItem(item){
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
				await axios.put('api/ProductosComprasMaps/'+item.id,{
					'Nombre':item.Nombre,
					'cantidad':1,
					'CodigoProducto':item.idarticulo,
					'PrecioUnitario':item.PrecioUnitario,
					'ValorImpuesto':item.ValorImpuesto,
					'Clave':this.IdReparacion,
					'Id':item.id,
				},configuracion).then(function(response){
					//alert("Orden Registrada con exito");
					me.Mensaje = 'Registro actualizado con exito '+response;
					me.snackbar = true;                  
				}).catch(err => {
					this.loading =false;
					//console.log(err.response);
					if (err.response.status==400){
						this.error="Problema eliminando producto";
					} else if (err.response.status==404){
						this.error="Problema eliminando";
					}else{
						this.error="NO se pudo eliminar";
					}
				});
		},
		async obtenerCliente(){
			var self = this;
			var clientesArray=[];
			var clientePrevio="";
			if (this.idcliente.text2 === undefined)
			{
				clientePrevio = this.idcliente;
			}
			else
			{
				clientePrevio = this.idcliente.text2;
				this.idcliente = this.idcliente.text2
			}
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/Empleados/ObtenerCliente', { params: {'clienteFactura': clientePrevio}},configuracion).then(function(response){
				clientesArray=response.data;
				self.clienteNombre = clientesArray[0].nombre;
				self.clienteCorreo = clientesArray[0].correo;
				self.clienteTelefono = clientesArray[0].telefono;
				self.clienteCedula = clientesArray[0].cedula;
				self.nombreComercial= clientesArray[0].nombreFantasia;
			})
		},
		async RegistrarOrden(){
			this.loading = true;
			this.error=null;
			let fechaActual = new Date(); // Esto obtiene la fecha y hora actual en JavaScript
			let fechaISO = fechaActual.toISOString(); // Esto convierte la fecha a una cadena en formato ISO 8601
			fechaISO = fechaISO.replace('Z', ''); // Elimina la 'Z' al final
			let accesoriosSeleccionados = this.inventario
				.filter(item => item.checked)
				.map(item => item.name)
				.join(', '); // Preparar la cadena de accesorios
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
			await axios.post('api/Reparaciones',{
				'Cliente':this.idcliente,
				'Articulo':this.articulo,
				'Domicilio': this.domicilio,
				'Marca': this.marca,
				'Modelo':this.modelo,
				'Tecnico': this.vendedor,
				'Falla':this.falla,
				'Nota': this.correo2,
				'Fecha':fechaISO, // Ingresar Fecha aqui
				'Serie':this.serie,
				'Adelanto':this.adelanto,
				'Referencia':this.referencia,
				'Capacidad':this.fuelLevel,
				'Accesorios':accesoriosSeleccionados,
				'Usuario':this.$store.state.usuario.nombre,
				'Estado':'Pendiente',
				'Costo':this.costo,
				'Localidad':this.$store.state.usuario.localidad,
				'Productos':this.items,
			},configuracion).then(function(response){
				//alert("Orden Registrada con exito");
				me.Mensaje = 'Registrado con exito '+response;
				me.snackbar = true;
				me.dialog = false;
				me.listar();
				me.limpiar();

				me.loading =false;                      
			}).catch(err => {
				this.loading =false;
				//console.log(err.response);
				if (err.response.status==400){
					this.error="Correo ocupado por otro cliente";
				} else if (err.response.status==404){
					this.error="Cédula Ocupada por otro cliente";
				}else{
					this.error="Validar Campos Vacios";
				}
			});
		},

		async ActualizarOrden(item){
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
			await axios.put('api/Reparaciones/'+item.id,{
					'Cliente':item.cliente,
					'Articulo':item.articulo,
					'ID':item.id,
					'Domicilio': item.domicilio,
					'Marca': item.marca,
					'Modelo':item.modelo,
					'Tecnico': item.tecnico,
					'Falla':item.falla,
					'Nota': item.nota,
					//'Fecha':fechaISO, // Ingresar Fecha aqui
					'Serie':item.serie,
					'Adelanto':item.adelanto,
					'Referencia':item.referencia,
					'Usuario':this.$store.state.usuario.nombre,
					'Accesorios':item.accesorios,
					'Estado':item.estado,
					'Costo':item.costo,
					'Localidad':this.$store.state.usuario.localidad,
				},configuracion).then(function(response){
					//alert("Orden Registrada con exito");
					me.Mensaje = 'Actualizado con exito '+response;
					me.snackbar = true;
					me.dialog = false;
					me.listar();
					me.loading =false;                      
				}).catch(err => {
					this.loading =false;
					//console.log(err.response);
					if (err.response.status==400){
						this.error="Correo ocupado por otro cliente";
					} else if (err.response.status==404){
						this.error="Cédula Ocupada por otro cliente";
					}else{
						this.error="Validar Campos Vacios";
					}
				});
		},
		async EliminarOrden(item){
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			let me=this;
			if (confirm("¿Estás seguro de que deseas eliminar esta orden?")) {
				me.loading = true;
				await axios.delete('api/Reparaciones/'+item.id,{
					'Cliente':item.cliente,
					'Articulo':item.articulo,
					'ID':item.id,
					'Domicilio': item.domicilio,
					'Marca': item.marca,
					'Modelo':item.modelo,
					'Tecnico': item.tecnico,
					'Falla':item.falla,
					'Nota': item.nota,
					'Serie':item.serie,
					'Adelanto':item.adelanto,
					'Referencia':item.referencia,
					'Usuario':this.$store.state.usuario.nombre,
					'Accesorios':item.accesorios,
					'Estado':item.estado,
					'Costo':item.costo,
					'Localidad':this.$store.state.usuario.localidad,
				},configuracion).then(function(response){
					//alert("Orden Registrada con exito");
					me.Mensaje = 'Actualizado con exito '+response;
					me.snackbar = true;
					me.dialog = false;
					me.listar();
					me.loading =false;                      
				}).catch(err => {
					this.loading =false;
					//console.log(err.response);
					if (err.response.status==400){
						this.error="Correo ocupado por otro cliente";
					} else if (err.response.status==404){
						this.error="Cédula Ocupada por otro cliente";
					}else{
						this.error="Validar Campos Vacios";
					}
				});
			}
		},
		async listar(){
			let me=this;
			this.localidad = me.$store.state.usuario.localidad;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.get('api/Reparaciones/ListarReparaciones/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.usuarios=response.data;
				me.modelCarga = false;
			}).catch(function(error){
				console.log(error);
			});
		},

		close () {
			this.dialog = false;
			this.limpiar();
		},
      
		limpiar(){
			this.nombre = "";
			this.tipoDocumento = "";
			this.cedula = "";
			this.genero = "",
			this.edad = 0,
			this.idLocalidadCliente = "";
			this.telefono = "";
			this.correo = "";
			this.correo2 = "";
			this.limiteCredito = 0;
			this.DiasCreditoCliente = 0;
			this.idcliente = '';
			this.articulo = '';
			this.domicilio = '';
			this.marca = '';
			this.modelo = '';
			this.vendedor = '';
			this.falla = '';
			this.correo2 = '';
			this.serie= '';
			this.adelanto = 0;
			this.referencia = '';
			this.costo = 0;
			this.items = [];
		},
		selectMecanicos(){
			this.vendedor = this.$store.state.usuario.nombre;
			let me=this;
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
			var proveedoresArray=[];
			axios.get('api/Usuarios/SelectMecanicosLocalidad/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
				proveedoresArray=response.data;
				proveedoresArray.map(function(x){
					me.Vendedores.push(x.nombre);
				});
			}).catch(function(error){
				console.log(error);
			});
		},
		BuscarPersona(){
			this.modelproveedor = true;
			let me=this;
			var familiasArray=[];
			axios.get('https://apis.gometa.org/cedulas/'+this.cedula+'&key=u0vSHKh0dVRckNH').then(function(response){
				familiasArray=response.data;
				me.nombre = familiasArray.results[0].fullname;
				me.tipoDocumento = familiasArray.results[0].guess_type
				
				
			}).catch(function(error){
			this.snackbar = true;
			this.Mensaje = 'Error de conexión con el TSE, digite los datos de forma manual'
				console.log(error);
			});
		},
		guardar() {
			this.loading = true;
			this.error=null;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			
				//Código para guardar
				let me=this;
				axios.post('api/Empleados/Crear',{
						'Nombre':this.nombre,
						'TipoCedula':this.tipoDocumento,
						'Cedula': this.cedula,
						'Localidad':this.$store.state.usuario.localidad,
						'Telefono':this.telefono,
						'Periodo': this.DiasCreditoCliente,
						'Correo':this.correo,
						'Fecha':this.fechanacimiento,
						'Correo2': this.correo2,
						'Edad':this.edad,
						'ListaPrecio':this.listaDePrecio,
						'Genero':this.genero,
						'Cantidad':this.limiteCredito,
						'Facebook':this.direccion,
						'Vendedor':this.vendedor,
						'NombreFantasia':this.nombreFantasia,
						'Celular':this.celular,
				},configuracion).then(function(response){
					me.limpiar(); 
					me.dialogcliente = false;
					me.loading =false;                       
				}).catch(err => {
					this.loading =false;
					//console.log(err.response);
					if (err.response.status==400){
						this.error="Correo ocupado por otro cliente";
					} else if (err.response.status==404){
						this.error="Cédula Ocupada por otro cliente";
					}else{
						this.error="Validar Campos Vacios";
					}
				});
		},
		NuevaOrden(){
			this.IdReparacion = 0;
		},
		editItem (item) {
			this.IdReparacion = item.id;
			this.idcliente=item.cliente;
			this.articulo=item.articulo;
			this.domicilio = item.domicilio;
			this.marca=item.marca;
			this.modelo = item.modelo;
			this.vendedor=item.tecnico;
			this.falla=item.falla;
			this.correo2 = item.nota;
			this.serie=item.serie;
			this.adelanto=item.adelanto;
			this.referencia = item.referencia;
			this.fuelLevel = item.capacidad;
			const accesoriosArray = item.accesorios ? item.accesorios.split(',') : [];
			this.usuario= item.usuario;
			this.estado=item.estado;
			this.costo=item.costo;
			this.celular= item.celular;
			this.dialog = true;
			this.vendedor = item.vendedor;
			// Actualizar el arreglo de inventario para marcar los items seleccionados
			this.inventario.forEach(invItem => {
				invItem.checked = item.accesorios.includes(invItem.name);
			});
			this.selectItems(item.id);
		},
		selectItems(id){
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
			let proveedoresArray = [];
			this.items = [];
			let me = this;
			axios.get('api/ProductosComprasMaps/Select/'+id,configuracion).then(function(response){
				proveedoresArray=response.data;
				proveedoresArray.map(function(x){
					me.items.push({ 
						Nombre: x.nombre,
						PrecioUnitario:x.precioUnitario,
						Cabys:x.cabys,
						idarticulo:x.codigoProducto,
						Clave:x.clave,
						id:x.id,
					}); 
				});
			}).catch(function(error){
				console.log(error);
			});
		},
		cargarColor(){
			for(var i = 0; i < this.localidadesColor.length; ++i)
			{
				if(this.localidadesColor[i].value == this.localidad.value){
					this.color = this.localidadesColor[i].color;
					break;
				}
			}
			},
		validar(){
			this.valida=0;
			this.validaMensaje=[];

			if (this.nombre.length<3 || this.nombre.length>100){
				this.validaMensaje.push("El nombre debe tener más de 3 caracteres y menos de 100 caracteres.");
			}
			if (!this.idrol){
				this.validaMensaje.push("Seleccione un rol.");
			}
			if (!this.tipo_documento){
				this.validaMensaje.push("Seleccione un tipo documento.");
			}

			if (!this.email){
				this.validaMensaje.push("Ingrese el email del usuario.");
			}
			if (!this.password){
				this.validaMensaje.push("Ingrese el password del usuario.");
			}
			if (this.validaMensaje.length){
				this.valida=1;
			}
			return this.valida;
        },

      

		close () {
			this.dialog = false
			setTimeout(() => {
			this.editedItem = Object.assign({}, this.defaultItem)
			this.editedIndex = -1
			}, 300)
		},
      	activarDesactivarMostrar(accion,item){
			this.adModal=1;
			this.adNombre=item.nombre;
			this.adId=item.idusuario;                
			if (accion==1){
				this.adAccion=1;
			}
			else if (accion==2){
				this.adAccion=2;
			}
			else{
				this.adModal=0;
			}
		},
		activarDesactivarCerrar(){
			this.adModal=0;
		},
       activar(item){
			let me=this;
			this.adId=item.idusuario;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.put('api/Usuarios/Activar/'+this.adId,{},configuracion).then(function(response){
				me.adModal=0;
				me.adAccion=0;
				me.adNombre="";
				me.adId="";
				me.listar();                       
			}).catch(function(error){
				console.log(error);
			});
		},
		desactivar(item){
			let me=this;
			me.$router.push({ name: 'perfilcliente/Pollos%20Jeffry%20San%20Roque/3101110410' });
			
		},
		save () {
			if (this.editedIndex > -1) {
			Object.assign(this.desserts[this.editedIndex], this.editedItem)
			} else {
			this.desserts.push(this.editedItem)
			}
			this.close()
		},
    },
  }
</script>
<style>
	.transparent-button {
	position: absolute;
	background-color: transparent; /* Hace el botón transparente */
	border: none; /* Elimina el borde */
	}
	.car-container {
	position: relative;
	}
	.py-2 {
	padding-top: 8px; /* Ajusta este valor según necesites */
	padding-bottom: 8px; /* Ajusta este valor según necesites */
	}
	.car-container img {
	max-width: 100%; /* Asegura que la imagen no sea más ancha que su contenedor */
	height: auto; /* Mantiene la proporción de la imagen */
	}
	.fuel-indicator img {
	max-width: 100%;
	height: auto;
	}
	.v-row.py-0 > .v-col.py-1 {
		padding-top: 4px; /* Reducir el espacio en la parte superior del v-col */
		padding-bottom: 4px; /* Reducir el espacio en la parte inferior del v-col */
	}
	.v-row.py-0 > .v-col.px-1 {
		padding-left: 4px; /* Reducir el espacio en la parte izquierda del v-col */
		padding-right: 4px; /* Reducir el espacio en la parte derecha del v-col */
	}
	@media only screen and (max-width: 600px) {
	.factura {
		font-size: smaller; /* Ajustar el tamaño del texto */
		padding: 10px; /* Reducir el padding si es necesario */
	}
	/* Ajustes adicionales para garantizar que todo se muestre correctamente */
	}

</style>